// para modificar una modalidad de torneo
export const SET_TORNEO = 'SET_TORNEO'
export const SET_COMPETITION = 'SET_COMPETITION'
export const SET_MODALIDAD_TORNEO = 'SET_MODALIDAD_TORNEO'
export const SET_MATCHES_TORNEO = 'SET_MATCHES_TORNEO'
export const SET_ESTADIOS_PARTIDOS = 'SET_ESTADIOS_PARTIDOS'
export const SET_JORNADAS_PARTIDOS = 'SET_JORNADAS_PARTIDOS'
export const SET_FIXTURES_TORNEO = 'SET_FIXTURES_TORNEO'
